module.exports = __webpack_public_path__ + "static/vwhead-bold-2959ac95cd5f024d468b539de2d2f44a.woff2";